<template>
	<div>
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1">Policies generated from proposal</div>
		</div>

		<div
			class="xs-12 flex wrap xs-middle r2 p2 cu2 c1 bg7--l4 b3 bc0 mt3"
			v-for="(policy, i) in policies"
			:key="i"
			@click="goToPolicy(policy)"
		>
			<div class="flex xs-between xs-12 fs3 lh125 mb2">
				<span class="c1 fw7">{{ policy.issuerNumber || "---" }}</span>
				<span class="c6">{{ `${policy.createdAt}` }}</span>
			</div>
			<div class="xs-12 lh125">
				<div class="lh125">
					{{ policy.product ? policy.product.name : "No product selected" }}
				</div>
				<div class="lh125">
					{{ policy.premium ? policy.premium.formattedPrice : "" }}
				</div>
			</div>
		</div>

		<!-- Empty -->
		<j-card class="mb2 bg4--l3 p4 ta2 fs3 c6" v-if="policies.length === 0">
			{{ $t("errors.no_data") }}
		</j-card>
	</div>
</template>

<script>
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

import JCard from "@/components/JCard"

export default {
	components: {
		JCard
	},

	data() {
		return {
			policies: []
		}
	},

	methods: {
		async fetchPolicies() {
			const query = gql`
				query fetchPolicies(
					$caseWhere: caseWhere
					$proposalWhere: proposalWhere
				) {
					cases(where: $caseWhere) {
						list {
							proposals(where: $proposalWhere) {
								policies {
									id
									issuerNumber
									createdAt
									product {
										name
									}
									premium {
										formattedPrice
									}
								}
							}
						}
					}
				}
			`

			const variables = {
				caseWhere: { id: this.$store.state.caseManagement.caseId },
				proposalWhere: { id: this.$store.state.caseManagement.proposalId }
			}

			const res = await api({
				query,
				variables
			})

			this.policies = res?.data?.cases?.list?.[0]?.proposals?.[0]?.policies
		},

		goToPolicy(policy) {
			this.$router.push({ name: "PolicyDetail", params: { id: policy.id } })
		}
	},

	mounted() {
		this.fetchPolicies()
	}
}
</script>
